export default {
  bad_connection:
    'インターネット接続がありません。ネットワーク接続を確認してから、もう一度お試しください。',
  send: '送信',
  select_hotel: 'Please select the hotel you are staying',
  select_language: 'ご利用の言語を選択してください。',
  start_chatting: 'Start Chatting',
  languages: '言語',
  menu: 'メニュー',
  close: '閉じる',
  back: '戻る',
  next: '次へ',
  message: 'ご質問を文章で入力してください',
  search: '検索',
  select: '選択',
  sign_in: 'サインイン',
  sign_out: 'ログアウト',
  sign_up: '登録',
  smoking: '喫煙可能',
  no_smoking: '禁煙',
  adults: '大人',
  xAdults: '大人',
  children: '小人',
  ageOfChild: '小人の年齢',
  seeAll: 'すべて表示',
  email: 'メールアドレス',
  email_confirmation: 'メールアドレス（確認用）',
  phone_number: '電話番号',
  icc: 'ICC',
  month: '月',
  year: '年',
  including_taxes: '税込み',
  excluding_taxes: '税抜き',
  show_more: 'もっと見る',
  show_less: '少なく見る',
  file_upload: {
    unsupported_file_type: '申し訳ありません。{file_type}　形式のファイルには対応しておりません。',
    file_size_exceeded: 'ファイルのサイズが許容制限の10MBを超えています',
    file_upload_failed: 'ファイルのアップロードに失敗しました',
    max_files_upload_simultaneously: '最大5つのファイルを同時にアップロードできます。'
  },
  base: {
    back_to_list: 'リストに戻る',
    pay: '支払い',
    cancel: 'キャンセル',
    delete: '削除',
    yes: 'はい',
    no: 'いいえ',
    book: '予約する',
    direct_price: '公式サイト価格',
    membership_rate: '会員価格',
    regular_rate: '通常価格',
    expand_for_price: '比較するために拡大',
    confirmSelection: '選択内容の確認',
    neverAskAgain: '今後表示しない',
    accept: '同意する',
    do_not_accept: '同意しない',
    password: 'パスワード',
    email: 'Eメール',
    save: '保存',
    confirm_password: 'パスワード確認',
    error02:
      '申し訳ございません、処理中にエラーが発生しました。少し時間を空けてから、再度お試しください。',
    errorCode: {
      3001: 'タイムアウトエラーが発生しました。決済処理は行われておりません。',
      3002: '決済処理に失敗しました。',
      3003: 'このカードはご利用できません。',
      3004: 'カード番号をご確認ください。',
      3005: '有効期限をご確認ください。',
      3006: '3Dセキュア認証に失敗しました。',
      3007: 'ご利用できないカードを入力されたか、カード番号に間違いがあります。',
      3008: '3Dセキュア認証がキャンセルされました。',
      3009: '複数回のリクエストを受けたので、3Dセキュア認証を中断しました。',
      3011: 'タイムアウトエラーが発生しました。決済処理は行われておりません。',
      3203: '申し訳ございません、処理中にエラーが発生しました。少し時間を空けてから、再度お試しください。',
      3204: '支払いプロセスが失敗しました。別のカードを使用するか、後で再試行してください。',
      3205: 'このカードはご利用できません。'
    }
  },
  triplaPayIssues: {
    INVALID_PARAMETER_SYNTAX: '入力内容をご確認ください。',
    INVALID_EXPIRATION_YEAR: '有効期限をご確認ください。',
    Invalid_card_number: 'カード番号をご確認ください。',
    Others: '入力内容をご確認ください。'
  },
  validation: {
    is_required: '{field}は必須項目です',
    correct_email: '正しいメールアドレスを入力してください',
    invalid_integer: '整数を入力してください'
  },
  chat_body: {
    deleted_message: 'メッセージを削除しました',
    op_deleted_msg: 'オペレーターがこのメッセージを削除しました',
    delete_message: 'メッセージを削除',
    delete_message_desc:
      'このメッセージを削除してもよろしいですか？ この操作は元に戻すことができません'
  },
  user_top: {
    information:
      'アカウント登録をして頂きますと他の端末でもアカウント登録前のチャットを閲覧することが出来ます。',
    terms_and_condition: {
      before: '',
      link: '利用規約',
      and: 'と',
      privacy_policy: 'プライバシーポリシー',
      after: 'に同意します。'
    },
    sign_in_with_facebook: 'Facebookアカウントでサインイン',
    sign_out_with_facebook: 'この端末でfacebookからサインアウトをする',
    sign_in_with_line: 'LINEアカウントでサインイン',
    sign_in_with_weibo: 'Weiboでサインイン',
    create_account: 'アカウント作成',
    or: 'または',
    already_have_an_account: '既にアカウントをお持ちの方',
    sign_in_with_email: 'メールアドレスでサインインする',
    forgot_password: 'パスワードをお忘れの方'
  },
  new_user: {
    information: 'お名前とメールアドレスを入力し「登録」をクリックしてください。',
    information2: 'chatbot@tripla.jpから認証メールが届きます。',
    first_name: '名',
    last_name: '姓',
    name_placeholder: 'お名前',
    email_placeholder: 'メールアドレス',
    submit: 'サインイン',
    email_sent:
      '登録確認のためのリンクがメールに送られました。メールの文中のリンクをクリックして{サインイン}して下さい。',
    error_message: {
      problem:
        'There was a problem creating your account. Please check your email address and try again.',
      email: 'このアドレスは無効であるか既に登録されています。'
    }
  },
  new_session: {
    information: 'メールアドレスとパスワードを入力し「サインイン」をクリックしてください。',
    email_placeholder: 'メールアドレス',
    password_placeholder: 'パスワード',
    submit: 'ログイン/会員登録',
    error_message: {
      email: 'メールアドレスまたはパスワードが間違っている可能性があります。',
      known_user_different: 'The known user is different'
    }
  },
  destroy_session: {
    information:
      'サインアウトしますか？ 今までのチャット内容を確認するには再度サインインが必要です。',
    submit: 'サインアウト'
  },
  forgotten_password: {
    information: 'メールアドレスを入力して下さい。 入力したアドレスに確認メールをお送りします。',
    email_placeholder: 'メールアドレス',
    submit: '送信',
    error: 'Unable to reset password'
  },
  forgotten_password_confirmation: {
    information: '入力したメールアドレスに変更のメールをお送りします。'
  },
  reset_password: {
    title: 'パスワードを変更する',
    password_title: 'パスワード',
    password_hint: '8文字以上',
    password_confirmation_title: 'パスワード（確認のため再度ご入力ください。）',
    submit: 'パスワードを変更する'
  },
  set_reset_password: {
    title: 'パスワードを変更する',
    information: 'パスワードが変更されました。',
    information2: '次回より変更済のパスワードでサインインして下さい。'
  },
  menu_items: {
    1: '空室照会',
    2: '宿泊予約',
    3: '予約確認'
  },
  modal: {
    back_to_chat: 'チャット画面に戻る'
  },
  gmoPaypalOptions: {
    visa: 'VISA',
    master: 'Mastercard',
    mastercard: 'Mastercard',
    amex: 'American Express',
    jcb: 'JCB',
    diners: 'Diners Club'
  },
  credit_card: {
    error: {
      cvv: 'CVVをご確認ください',
      expiration: '有効期限をご確認ください',
      name: 'カードの名前をご確認ください',
      number: 'カード番号をご確認ください',
      unknown: '処理が中断されました。入力した情報をご確認ください。',
      reservation_month: '有効期限が予約月以降のカードを入力してください。'
    },
    accept: 'ご利用可能カード:',
    cvv: 'セキュリティコード',
    expiration: '有効期限',
    intro: 'ご利用になるカードの情報を入力してください',
    name: 'カード名義人',
    number: 'カード番号',
    save: 'このカードを保存する',
    submit: '送信',
    title: 'カード登録',
    security_code: 'セキュリティコード',
    card_holder_confirm: 'カード名義をご確認ください',
    card_holder_format_confirm: '名前は半角のローマ字で入力してください',
    expiration_confirm: '有効期限をご確認ください',
    card_cvv_confirm: 'セキュリティコードをご確認ください',
    card_number_confirm: 'カード番号をご確認ください',
    card_brand: 'カードブランド',
    select_card_brand: 'カードブランドを選択してください'
  },
  payment: {
    total: '合計'
  },
  currencies: {
    JPY: '円'
  },
  chat_channels: {
    title: 'チャンネルを選択する',
    facebook: 'メッセンジャー',
    web: 'ウェブ',
    line: 'LINE',
    whats_app: 'WhatsApp'
  },
  rev_requests: {
    title: 'リクエスト一覧',
    request: 'リクエスト',
    status: 'ステータス',
    no_data: '現在、リクエストはありません',
    payment: '支払い',
    customer: 'お客様名',
    phone: '電話番号',
    people: '人数',
    facility_name: '施設名',
    requested_day: '希望日',
    requested_time: '希望時間',
    confirm_cancel_msg:
      'このリクエストの取消を確認してください。管理者に通知を送信し、取消が完了すると、確認のメールが届きます。',
    cancel_request: 'リクエスト取消',
    edit_request: 'リクエスト編集',
    keep_request: 'リクエスト保持'
  },
  requests: {
    statuses: {
      _destroyed: '削除済',
      cancel_requested: '要キャンセル',
      cancelled: 'キャンセル済',
      change_requested: '変更中',
      created: '要対応',
      departure_unconfirmed: '催行未定',
      done: '対応済',
      in_progress: '確認中',
      no_show: 'ノーショウ',
      stopped: '催行中止',
      wait_listed: 'キャンセル待ち',
      waiting_detail: '詳細待ち'
    }
  },
  best_rate: 'ベスト価格',
  time_picker: {
    AM: '午前',
    PM: '午後'
  },
  details_page: {
    details: '詳細を確認する'
  },
  date_range: {
    select: '宿泊日を選択してください',
    send: '「選択」をクリックして進んでください。',
    no_disabled_dates: '満室のお日にちは選択できません。お手数ですが再度宿泊日を選択してください。'
  },
  facebook: {
    email_sent: '予約の確認メールを送信しました。メールに添付のURLより予約を確定してください。',
    no_email: 'メールアドレスを入力してください。ご予約完了後、予約確認メールを送信いたします。',
    signInFailed: 'ログインに失敗しました。お手数ですが再度お試しください。',
    sign_out: '下のボタンをクリックしてFacebookをサインアウトしてください。'
  },
  confirm_form: {
    search: '再度検索する',
    update_contact: 'お客様情報を更新する'
  },
  contact_form: {
    update: '更新',
    submit: '送信',
    full_name: 'お名前(ひらがな)',
    family_name: '姓（ひらがな）',
    first_name: '名（ひらがな）',
    cc_email: '同じ文面のメールを送付するアドレス',
    error: {
      full_name_error: 'お名前をひらがなで入力してください',
      tel_format_error: '電話番号として使用できるのは、数字、スペース、()-+です。',
      tel_length_error: '電話番号は9桁以上入力してください。',
      email_format_error: '正しいメールアドレスをご入力下さい。(入力例 name@gmail.com)',
      email_confirmation_error: 'email addresses not identical'
    }
  },
  room_not_available:
    '申し訳ございません。お探しのプランではご利用できるお部屋がございません。条件を変更して再度ご検索をお願いいたします。',
  search_again: '再度検索する',
  room_not_available_short: '販売なし',
  email_form: {
    note_placeholder: 'リクエストの詳細をご入力ください。'
  },
  rental_car_form: {
    pickup_title: '貸出店舗',
    pickup_area: 'エリア選択',
    pickup_shop: '店舗選択',
    pickup_date_time: '貸出日時',
    return_title: '返却店舗',
    return_area: 'エリア選択',
    return_shop: '店舗選択',
    return_date_time: '返却日時',
    back: '戻る'
  },
  search_area_form: {
    select_prefecture_area: '都道府県とエリアを選択してください',
    prefecture: '都道府県',
    area: 'エリア'
  },
  restaurant_form: {
    breakfast: '朝食',
    lunch: 'ランチ',
    dinner: 'ディナー',
    main_time: '希望時間',
    alternative_times: '予備時間',
    pick_multiple: '複数選択可',
    any_available_time: 'すべての予備時間を選択'
  },
  terms_of_use: '利用規約',
  privacy_policy: '個人情報の取扱い',
  browser_warning:
    'お使いのブラウザは最新版ではありません。速度や安全性を向上するために、ブラウザを更新してください。',
  for_night: '{n}泊の料金',
  chat_icon: {
    chat: 'チャット'
  },
  chat_evaluation: {
    title: '顧客満足度調査',
    msg: 'チャットボットサービスに満足していますか？',
    not_satisfied: '不満足',
    satisfied: '満足'
  },
  cookie_consent: {
    title: 'Cookieの管理',
    necessary: '必須: チャット履歴とログイン状態を保存します。',
    functional: '機能: プライバシーポリシーやチャットボットのレイアウトなどの設定を保存します。',
    performance:
      '品質改善: このCookieは、訪問数とクリック数を保存して、チャットボットサービス改善のために利用されます。',
    advertising: '広告: このCookieは、お客様に関連性の高い広告を表示するために利用されます。',
    accept_all: '受け入れる',
    confirm: '一部分受け入れる',
    cookies_accepted: 'クッキーを受け入れる'
  },
  ota_name: {
    agoda: 'Agoda',
    booking_com: 'Booking com',
    expedia: 'Expedia',
    jalan: 'じゃらん',
    rakuten_travel: '楽天トラベル',
    rakutenTravel: '楽天トラベル'
  }
}
